import styled from 'styled-components';

export const Main = styled.main`
  display: flex;
  flex-direction: column;
`;
